import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Card, Row, Col, Popover } from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';




import './analytics.css';


var cc_data;

class BuSwitchCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		const { opensearchBuSwitchList, loading, userTheme } = this.props;

		cc_data = opensearchBuSwitchList || [];
		cc_data.forEach((c,d)=>{
			cc_data[d].key_as_string = moment(new Date(c.key_as_string)).format("MMM-DD")
		})

		let dataset = [];
		
		cc_data.forEach((c , h) => {
			if(c.buAfter && c.buAfter.buckets){
				c.buAfter.buckets.forEach((f, g ) =>{
					if(!dataset.find(d => d.name === f.key)){  // can not find the bu switch series from dataset, need to assign a new one.
						let tempcount = [];
						if(h > 0){		// not first day, need to push 0 count , otherwise, data count will go to the first day.
							for(let i=0; i<h; i++){
								tempcount.push(0);
							}
							tempcount.push(f.doc_count);
						}else{
							tempcount = [f.doc_count];  // first date, push count directly.
						}
						dataset.push({name : f.key, type : 'bar', data : tempcount});
					} else {
						let obj = dataset.find(d => d.name === f.key);
						obj.data.push(f.doc_count);
					}
				})
				if(c.buAfter.buckets.length < dataset.length){ // that day has missing data count, need to add 0.
					let temp = [];
					c.buAfter.buckets.forEach(d =>{
						temp = dataset.filter(f => f.name !== d.key);
					})
					temp.forEach(g => {
						g.data.push(0);
					})
				}
			}
		})
		const option = {
			tooltip: {
			  trigger: 'axis',
			  axisPointer: {
				type: 'shadow'
			  },
			  formatter: function (data) {
				let fdata = data[0].name; // display date : Dec-12 
				data.forEach(d => {
					fdata += '<br/>' + d.seriesName + ' : ' + d.value; // display series data
				})
				// fdata += '<br/>' + 'total : '+ cc_data[data[0].dataIndex].doc_count; // display total count
				fdata += `<br/>total : ${cc_data[data[0].dataIndex].doc_count}`; // display total count
				return fdata;
			  }
			},
			legend: {},
			grid: {
			  left: '3%',
			  right: '4%',
			  bottom: '3%',
			  containLabel: true
			},
			yAxis: {
			  type: 'value',
			  boundaryGap: [0, 0.01]
			},
			xAxis: {
			  type: 'category',
			  data: cc_data.map(d => d.key_as_string)
			},
			series: dataset
		  };

		  let csv_data = [];
		  cc_data.forEach( (c,i)=> {
			dataset.forEach(d => {
				  if(d){
					  csv_data.push({date : c.key_as_string, platforms : d.name , count : d.data[i]})
				  }
			  })
			csv_data.push({date : c.key_as_string, platforms: 'total', count : c.doc_count})
		  })

		return (
			<Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`BU Switch  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='BuSwitchCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={csv_data} target="_blank" filename={"BU Switch.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
					<Col span={24}>
						<ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{ color: "#74add1" }} />
					</Col>
				</Row>
			</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchBuSwitchList: state.analytics.opensearchBuSwitchList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BuSwitchCard));
